import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {ThemeService} from '@lv1871/core';
import {FondsService} from '../../../services/fonds.service';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Fonds} from '../../../models/fonds';

interface DonutData {
  fondsId: number;
  prozentualerAnteil: number;
  name: string;
}

@Component({
    selector: 'lv-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss'],
    standalone: false
})
export class DonutChartComponent implements OnChanges, AfterViewInit {
  @ViewChild('canvas', {static: true}) canvas: ElementRef<HTMLCanvasElement>;
  @Input()
  url: string;
  readonly colors = [];
  public allFonds$: Observable<Fonds[]>;
  private _data: DonutData[];

  constructor(private _themeService: ThemeService, private cd: ChangeDetectorRef, private _fondsService: FondsService) {

  }

  get data(): DonutData[] {
    return this._data;
  }

  @Input()
  set data(value: DonutData[]) {
    this._data = value;
  }

  @HostListener('window:resize', ['$event'])
  onResize(_?) {
    const canvas = this.canvas.nativeElement;
    const context = canvas.getContext('2d');
    const windowSize = Math.min(window.innerWidth, window.innerHeight) * 0.35;

    canvas.width = windowSize;
    canvas.height = windowSize;
    context.scale(windowSize * 0.5, windowSize * 0.5);
    this.drawDonut(context);
  }

  ngOnChanges(): void {
    this.allFonds$ = this._fondsService.getAllFonds().pipe(
        map(fondsMap => {
          const fondsNameMap = new Map<number, string>();
          fondsMap.forEach(fonds => {
            fondsNameMap.set(fonds.fondsId, fonds.name);
          });
          this.data.forEach(fondsgruppenItem => {
            fondsgruppenItem.name = fondsNameMap.get(fondsgruppenItem.fondsId);
          });
          return fondsMap;
        }),
    );
    for (let i = 100; i <= 800; i += 100) {
      this.colors.push(this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary-' + i));
      this.colors.push(this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary-' + i));
      //TODO add ternary-color when available
      //this.colors.push(this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-ternary-' + j));
    }
    this.drawDonut(this.canvas.nativeElement.getContext('2d'));
  }

  ngAfterViewInit(): void {
    this.onResize();
  }

  sortedDonatDataList() {
    if (this.prozentualeAnteileIdentisch()) {
      return this._data.sort((a, b) => a.name?.toLowerCase().localeCompare(b.name?.toLowerCase()));
    }
    return this._data.sort((a, b) => b.prozentualerAnteil - a.prozentualerAnteil);
  }

  prozentualeAnteileIdentisch() {
    for (let i = 1; i < this._data.length; i++) {
      if (this._data[i].prozentualerAnteil !== this._data[0].prozentualerAnteil) {
        return false;
      }
    }
    return true;
  }
  trackByFondsId(item: DonutData) {
    return item.fondsId;
  }


  drawDonut(context): void {
    let arcAngle = Math.PI * 1.5;
    let colorIndex = 0;
    context.lineWidth = 0.3;

    this._data
        .forEach(fraction => {
          context.beginPath();
          context.strokeStyle = this.colors[colorIndex % this.colors.length];
          context.arc(1, 1, 0.7,
              arcAngle, arcAngle + (Math.PI * 2) * (fraction.prozentualerAnteil / 100));
          context.stroke();
          colorIndex++;
          arcAngle += (Math.PI * 2) * (fraction.prozentualerAnteil / 100);
        });
  }
}
